export enum KeyCode {
    UP = 38,
    DOWN = 40,
    ESCAPE = 27,
}
